<div>
  <div> <h2 style="color: #9b7544"> Payment </h2>  </div>
  <br>
  <div> 
      <a style="font-size: 20px; color: #9b7544">The booking will be confirmed only after receiving the payment. 
          Our representative will contact you shortly.</a>
    </div>
  <br> 
  <mat-radio-group>
    <mat-radio-button checked="Online" aria-label="Online" value="Online" (click)="insert('Online')" >
<a style="font-size: 19px;color: #9b7544" >  Pay Now By Online Payment Method </a>
</mat-radio-button>
<br>
<mat-radio-button value="Offline" (click)="insert('Offline')" > 
    <a style="font-size: 19px; color: #9b7544">  Pay Offline </a>
</mat-radio-button>
  </mat-radio-group>

<br>
  <button  class="btn btn-outline-success btn-block" style=" border-radius: 25px; margin-top: 30px" *ngIf="paym !== undefined"(click)="pay()"> Submit </button>
</div>


   
